import { helpers, elements } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as selector from './tools.js'

const { parseInt } = Number

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { value: buttonValue, ownerDocument } = button
    const container = closest(`.${helpers.dateSelector.elements.container}`, button)
    const { lang } = ownerDocument
    const label = one(`.${helpers.dateSelector.elements.nav_months} .${elements.button_text}`, container)
    let currentDate

    currentDate = new Date(parseInt(buttonValue, 10) * 86400 * 1000)

    selector.setCurrentDay(container, currentDate)
    selector.toggleView(container, 'years')

    if (label) {
      label.textContent = new Intl.DateTimeFormat(lang, {
        month: 'long',
        year: 'numeric',
        timeZone: 'GMT'
      }).format(currentDate)
    }

    selector.setDays(container, currentDate)
  }
})

export default button => {
  onClick.listen(button)
}
